export default __webpack_public_path__ + "static/media/fav-property.a76a7259.svg";